import { requestMcisCutoverRollbackResend as postMcisCutoverRollbackResend } from '@/console/api/mcisCutoverRollbackResend'
import { McisCutoverRollbackResendRequest, McisCutoverRollbackResendResponse } from '@/console/api/types'

/** MCIS 컷오버 롤백 재송신. `api/mcisCutoverRollbackResend.ts` 로 그대로 위임한다 — 재시도를 얹지 않는다. */
export const requestMcisCutoverRollbackResend = (request: McisCutoverRollbackResendRequest): Promise<McisCutoverRollbackResendResponse> =>
  postMcisCutoverRollbackResend(request)
